import { render, staticRenderFns } from "./WalletWithdraw.vue?vue&type=template&id=b27d6460"
import script from "./WalletWithdraw.vue?vue&type=script&lang=js"
export * from "./WalletWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports